import React from "react";
import PageHeader from "../components/common/PageHeader";
import PageMeta from "../components/common/PageMeta";
import Navbar from "../layout/Header/Navbar";
import Layout from "../layout/Layout";
import FooterSocial from "../layout/Footer/FooterSocial";
import SecretList from "../components/secret/SecretList";

const SecretKey = () => {
    return (
        <Layout>
            <PageMeta title="Contact-Software &amp; IT Solutions HTML Template" />
            <Navbar navDark />
            <PageHeader title="Secret Keys" />
            <SecretList />
            <FooterSocial />
        </Layout>
    );
};

export default SecretKey;
